






import { defineComponent, ref } from '@vue/composition-api';
export default defineComponent({
  name: 'DebounceTooltip',
  setup() {
    const visible = ref<boolean>(false);
    const methods = {
      onMouseEnter() {
        visible.value = true;
      },
      onMouseLeave() {
        visible.value = false;
      },
    };
    return {
      ...methods,
      visible,
    };
  },
});
